// extracted by mini-css-extract-plugin
export default {"wrapper":"ZoomPhotoPopup_wrapper__Yjgu6","logo":"ZoomPhotoPopup_logo__MY3bD"};